import { createContext, useContext } from 'react';

/**
 * Lets any page open the shell's modals (cart) or navigate to auth pages
 * without prop-drilling through the router. Cart/counsel/doubt modals live in
 * Layout because the header opens them from every route — mirroring the
 * prototype. openAuth() now routes to /login or /register.
 */
export interface UIActions {
  openCart: () => void;
  /** Navigate to /login or /register (replaces the old auth modal). */
  openAuth: (mode: 'login' | 'signup') => void;
  /** toast() (:726) — the prototype's confirmation bar, callable from anywhere. */
  toast: (message: string) => void;
  /** openCounsel() (:5167) — the 1:1 counselling modal, opened from several pages. */
  openCounsel: (preset?: { goal?: string; slot?: string; centreSlug?: string; centreName?: string }) => void;
  /** openDoubt() (:4300) — AskMAK doubt-solve chat for a course; login-gated. */
  openDoubt: (courseSlug: string) => void;
}

const Ctx = createContext<UIActions | null>(null);

export const UIProvider = Ctx.Provider;

export function useUI(): UIActions {
  const v = useContext(Ctx);
  if (!v) throw new Error('useUI must be used inside <UIProvider>');
  return v;
}
